import { useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Loading from "components/atoms/Loading";
import { UserContext } from "components/context/UserContext";
import { useLocalStorage } from "components/hooks";
import UserProfile from "./UserProfile";
import { useWalkthroughContext } from "./walkthrough/WalkthroughContext";
import { LOCAL_STORAGE_KEYS } from "../../constants";

function UserProfilePage() {
  const { userDetails, loading } = useContext(UserContext);

  const [searchParams, setSearchParams] = useSearchParams();
  const { stepFromUrl, setTourToState } = useWalkthroughContext();
  const [skipOnboardingFlag] = useLocalStorage(LOCAL_STORAGE_KEYS.SKIP_ONBOARDING);

  useEffect(() => {
    if (userDetails?.magnetiq_program_status === 1 && !skipOnboardingFlag) {
      if (stepFromUrl === null) {
        searchParams.set("onboarding-step", "0");
        setSearchParams(searchParams, { replace: true });
      }
      setTourToState(true);
    } else {
      setTourToState(false);
    }

    return () => {
      setTourToState(false);
    };
  }, [userDetails?.magnetiq_program_status]);

  return loading || !userDetails ? <Loading /> : <UserProfile userDetails={userDetails} isPublicProfile={false} />;
}
export default UserProfilePage;
